<sd-dropdown dropdownCustomId="dropdownAccount"
  [brand]="brand"
  class="{{isLoggedIn ? 'is-logged' : ''}}"
  [iconSize]="isDevice$ ? iconSize.medium : iconSize.small"
  icon="icon-account"
  [iconLabel]="isLoggedIn ? account?.userName : undefined"
  [buttonIconTitle]="(isLoggedIn ? 'account.dropdown.a11y.myAccountConnected' : 'account.dropdown.a11y.myAccount') | translate"
  [buttonIconTitleHidden]="true"
  (isOpenedChange)="onOpenedChange($event)">
  @if (!isLoggedIn) {
    <ng-container sd-dropdown-menu>
      <div class="c__unregistered">
        <sd-title customClass="brand--h5 is-regular">
          {{ "account.dropdown.login.title" | translate }}
        </sd-title>
        <p class="c__description is-caption">
          {{ "account.dropdown.login.description" | translate }}
        </p>
        <div class="c__actions">
          <div class="c__login">
            <p class="is-caption is-semi-bold">
              {{ "account.dropdown.login.label" | translate }}
            </p>
            <button sd-button (click)="onLogin()">
              {{ "account.dropdown.login.action" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  } @else {
    <div sd-dropdown-menu class="c__logged-in">
      <sd-title customClass="brand--h5 is-regular">
        {{ "account.dropdown.welcome" | translate: {userName: account?.userName} }}
      </sd-title>
      <ul sd-list-block>
        @for (link of account?.links; track link) {
          <li
            tabindex="1"
            class="c__option">
            <sd-link [link]="link"
              customClass="is-reset"
              [tabIndex]="1"
              (clicked)="closeDropdown()">
              {{ link?.linkName }}
            </sd-link>
          </li>
        }
      </ul>
      <div class="c__actions">
        <button sd-button
          (click)="onLogout()"
          icon="icon-account"
          [isSmall]="true">
          <span>{{ "account.dropdown.logout" | translate }}</span>
        </button>
      </div>
    </div>
  }

</sd-dropdown>
